export const firebaseConfig = {
};
